import { createAction, createAsyncAction } from 'typesafe-actions'
import { UserAuthenticated } from './types'
import { NavigateFunction } from 'react-router'

export const saveAuthUser = createAction('@user/SAVE_AUTH_USER_SUCCESS')<UserAuthenticated>()

type SignInParams = {
  companyId: string
  email: string
  password: string
  navigate: NavigateFunction
  callback?: (params: {
    userToken?: string
    userEmail?: string
    userId?: string
    twoFactorRequired?: boolean
    preAuthTicket?: string
  }) => void
}

export const signInAsync = createAsyncAction('@user/SIGN_IN_REQUEST', '@user/SIGN_IN_SUCCESS', '@user/SIGN_IN_FAILURE')<
  SignInParams,
  { userAuthenticated: UserAuthenticated },
  { message: string }
>()

export const signOutAsync = createAsyncAction(
  '@user/SIGN_OUT_REQUEST',
  '@user/SIGN_OUT_SUCCESS',
  '@user/SIGN_OUT_FAILURE'
)<UserAuthenticated | null, void, void>()

type VerifyTwoFactorParams = {
  preAuthTicket: string
  code: string
  companyId: string
  navigate: NavigateFunction
}

export const verifyTwoFactorAsync = createAsyncAction(
  '@user/VERIFY_2FA_REQUEST',
  '@user/VERIFY_2FA_SUCCESS',
  '@user/VERIFY_2FA_FAILURE'
)<VerifyTwoFactorParams, { userAuthenticated: UserAuthenticated }, { message: string }>()

export const resendTwoFactorCodeAsync = createAsyncAction(
  '@user/RESEND_2FA_REQUEST',
  '@user/RESEND_2FA_SUCCESS',
  '@user/RESEND_2FA_FAILURE'
)<{ preAuthTicket: string }, void, { message: string }>()

export { fetchOperatorsAction, fetchUserPermissionAction, updateUserAction, updateUserOnMainApiAction } from './handles'
